import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store'
import VueDraggable from 'vue-draggable'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import * as Sentry from "@sentry/vue";
import { version } from '../package.json'

Vue.config.productionTip = false
Vue.use(VueMoment, {
  moment,
})
Vue.use(VueDraggable)

// Only initialize Sentry when a DSN is configured (e.g. local dev has none) so
// the app boots normally without crashing or logging noise.
if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
    ],
    environment: process.env.VUE_APP_ENVIRONMENT || 'production',
    release: version,
  });
}


Bugsnag.start({
  apiKey: 'bd504ab1c8228d9273068ce1bb7cf769',
  plugins: [new BugsnagPluginVue()],
  onError: function (event) {
    if(window !== null && window !== undefined && window.processDisplaySystem !== null && window.processDisplaySystem !== undefined) {
      event.addMetadata('display', window.processDisplaySystem)
    }
  }
})

const bugsnagVue = Bugsnag.getPlugin('vue')
bugsnagVue.installVueErrorHandler(Vue)

new Vue({
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
